import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { fetchExportInputValuesDownloadUrl } from '@app/store/transport-layer/document/export-input-values-jobs/download';

export default function useExportInputValuesDownloadUrl({
  jobId,
  options,
}: {
  jobId: string;
  options?: UseQueryOptions<{ url: string }, AxiosError>;
}) {
  const workspaceId = useWorkspaceId();
  return useQuery<{ url: string }, AxiosError>(
    ['exportInputValuesDownloadUrl', jobId],
    () => fetchExportInputValuesDownloadUrl({ jobId, workspaceId }),
    options
  );
}
